var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-settings"},[_c('EditForm',{attrs:{"form-id":_vm.formId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }